import React from "react"
import { Button } from "@mui/material"
import { useTheme } from "@mui/system"

function DMVButtonNav({ children, isActive = false, onPress = () => {}, style = {} }) {
  const themes = useTheme()

  return (
    <Button
      onClick={onPress}
      style={{
        background: `${
          isActive
            ? `var(--dmv-button, linear-gradient(137deg, #4FACE9 0%, #274C9A 89.65%))`
            : themes.palette.dmv.main
        }`,
        opacity: `${isActive ? "1" : "0.5"}`,
        padding: "12px 26px 12px 26px",
        marginRight: "6px",
        textTransform: "none",
        ...style
      }}
      variant="contained">
      {children}
    </Button>
  )
}

export default DMVButtonNav
